import React, { Fragment } from 'react';
export function Timeline() {
  const timelineEvents = [{
    title: 'Submission of Strings To Early Warning Report',
    date: 'Now - 5 weeks Before the Application Closes',
    color: 'from-primary-600 to-primary-700',
    description: 'Participants submit the strings that they are interested in applying for',
    cost: '$1,000 per string',
    highlight: true
  }, {
    title: 'Application Window Opens',
    date: 'April 2026',
    color: 'from-blue-600 to-blue-700',
    description: 'ICANN opens the application window for new gTLD applications'
  }, {
    title: 'Pre-Application Early Warning Report',
    date: '4 Weeks Before Close of the Application Window',
    color: 'from-primary-600 to-primary-700',
    description: 'Participants receive notice of potential contention and can contact others anonymously',
    highlight: true,
    durationAfter: '4 Weeks'
  }, {
    title: 'Application Window Closes',
    date: 'August 2026',
    color: 'from-blue-600 to-blue-700',
    description: 'Deadline for submitting new gTLD applications to ICANN',
    durationAfter: '1 Week'
  }, {
    title: 'Submission of Strings To Early Warning Report',
    date: 'Within 1 week of the Application Window Closing',
    color: 'from-primary-600 to-primary-700',
    description: 'Participants submit the strings that they actually applied for',
    cost: '$3,000 per string',
    discountNote: '($2,000 per strings submitted in the prior stage)',
    highlight: true
  }, {
    title: 'Post-Application Early Warning Report',
    date: '6 Weeks Before Reveal Day',
    color: 'from-primary-600 to-primary-700',
    description: 'Final opportunity to identify contention and take steps to avoid it',
    highlight: true,
    durationAfter: '6 Weeks'
  }, {
    title: 'Reveal Day',
    date: 'TBD 2026',
    color: 'from-red-600 to-red-700',
    description: 'ICANN reveals all applications. Private resolution prohibited after this point'
  }, {
    title: 'Prohibition on Private Resolution',
    date: 'Reveal Day Until Execution of the Registry Agreement for the Each String in Contention',
    color: 'from-yellow-400 to-yellow-500',
    description: 'Applicants may not engage in any private resolution of contention sets'
  }];
  return <div className="w-full py-12" data-id="element-276">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-700 mb-12 text-center" data-id="element-277">
        2026 Round New gTLD Application Submission and Early Warning Timeline
      </h2>
      <div className="max-w-6xl mx-auto relative" data-id="element-278">
        {/* Vertical timeline line - left on mobile, centered on desktop */}
        <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-300 via-blue-300 to-gray-300 md:transform md:-translate-x-1/2" data-id="element-279"></div>
        {/* Timeline events */}
        <div data-id="element-280">
          {timelineEvents.map((event, index) => {
          // Special positioning for cards 6 and 7
          const isLeft = index === 5 ? true : index === 6 ? false : index % 2 === 0;
          // Make card 1 (index 0) taller
          const isExtendedCard = index === 0;
          // Position card 2 in the middle of card 1's extended area, card 3 below card 1
          const cardSpacing = index === 0 ? '' : index === 1 ? 'mt-8 md:-mt-80' : index === 2 ? 'mt-8 md:mt-56' : index === 3 ? 'mt-8 md:mt-32' : index === 6 ? 'mt-8 md:mt-0' : 'mt-8 md:mt-12';
          return <Fragment key={index} data-id="element-281">
                <div className={`relative flex items-center ${isLeft ? 'justify-start' : 'md:justify-end justify-start'} ${cardSpacing}`} data-id="element-282">
                  {/* Timeline dot with step number - left on mobile, centered on desktop */}
                  <div className="absolute left-6 md:left-1/2 top-0 md:transform md:-translate-x-1/2 z-10 flex flex-col items-center -translate-x-1/2" data-id="element-283">
                    <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-r ${event.color} ${event.highlight ? 'ring-4 ring-primary-200' : 'ring-2 ring-white'} shadow-lg flex items-center justify-center`} data-id="element-284">
                      <span className="text-white font-bold text-base md:text-lg" data-id="element-285">
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  {/* Card - full width on mobile, half width on desktop */}
                  <div className={`w-full md:w-5/12 pl-16 md:pl-0 ${isLeft ? 'md:pr-12' : 'md:pl-12'}`} data-id="element-286">
                    <div className={`bg-white rounded-2xl shadow-xl overflow-hidden border ${event.highlight ? 'border-primary-300 ring-2 ring-primary-200' : 'border-secondary-100'} hover:shadow-2xl hover:scale-105 transition-all duration-300 group`} data-id="element-287">
                      <div className={`bg-gradient-to-r ${event.color} text-white p-4 md:p-6 relative overflow-hidden`} data-id="element-288">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full opacity-10 blur-2xl -mt-16 -mr-16" data-id="element-289"></div>
                        <div className="relative z-10" data-id="element-290">
                          <div className="text-xs font-semibold opacity-90 mb-2" data-id="element-291">
                            {event.date}
                          </div>
                          <h3 className="font-display text-base md:text-lg font-bold leading-tight" data-id="element-292">
                            {event.title}
                          </h3>
                        </div>
                      </div>
                      <div className={`p-4 md:p-6 ${isExtendedCard ? 'pb-24 md:pb-96' : ''}`} data-id="element-293">
                        <p className="text-secondary-700 leading-relaxed text-sm md:text-base" data-id="element-294">
                          {event.description}
                        </p>
                        {event.cost && <div className="mt-4" data-id="element-295">
                            <p className="text-primary-700 font-semibold text-sm md:text-base" data-id="element-296">
                              Cost: {event.cost}
                            </p>
                            {event.discountNote && <p className="text-primary-600 text-xs md:text-sm mt-1" data-id="element-297">
                                {event.discountNote}
                              </p>}
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Duration indicator below card - visible only on mobile */}
                {event.durationAfter && <div className="flex justify-center mt-4 md:hidden pl-16" data-id="element-298">
                    <div className="bg-primary-50 px-4 py-2 rounded-full border-2 border-primary-300" data-id="element-299">
                      <span className="text-primary-700 font-bold text-sm" data-id="element-300">
                        {event.durationAfter}
                      </span>
                    </div>
                  </div>}
                {/* Duration indicator between circles - visible only on desktop */}
                {index === 2 && <div className="hidden md:flex relative items-center justify-center -mt-16 mb-16" data-id="element-301">
                    <div className="absolute left-1/2 transform -translate-x-1/2 bg-white px-6 py-2 rounded-full shadow-lg border-2 border-primary-300 z-20" data-id="element-302">
                      <span className="text-primary-700 font-bold text-lg" data-id="element-303">
                        4 Weeks
                      </span>
                    </div>
                  </div>}
                {index === 3 && <div className="hidden md:flex relative items-center justify-center -mt-16 mb-16" data-id="element-304">
                    <div className="absolute left-1/2 transform -translate-x-1/2 bg-white px-6 py-2 rounded-full shadow-lg border-2 border-primary-300 z-20" data-id="element-305">
                      <span className="text-primary-700 font-bold text-lg" data-id="element-306">
                        1 Week
                      </span>
                    </div>
                  </div>}
                {index === 5 && <div className="hidden md:flex relative items-center justify-center -mt-16 mb-16" data-id="element-307">
                    <div className="absolute left-1/2 transform -translate-x-1/2 bg-white px-6 py-2 rounded-full shadow-lg border-2 border-primary-300 z-20" data-id="element-308">
                      <span className="text-primary-700 font-bold text-lg" data-id="element-309">
                        6 Weeks
                      </span>
                    </div>
                  </div>}
              </Fragment>;
        })}
        </div>
      </div>
      {/* Legend */}
      <div className="mt-12 px-4" data-id="element-310">
        <div className="flex flex-col sm:flex-row flex-wrap justify-start gap-4 md:gap-6 text-xs md:text-sm" data-id="element-311">
          <div className="flex items-center gap-2 justify-start" data-id="element-312">
            <div className="w-3 h-3 md:w-4 md:h-4 bg-gradient-to-r from-primary-600 to-primary-700 rounded ring-2 ring-primary-200 flex-shrink-0" data-id="element-313"></div>
            <span className="text-secondary-700 font-semibold" data-id="element-314">
              Early Warning String Submission
            </span>
          </div>
          <div className="flex items-center gap-2 justify-start" data-id="element-315">
            <div className="w-3 h-3 md:w-4 md:h-4 bg-gradient-to-r from-blue-600 to-blue-700 rounded flex-shrink-0" data-id="element-316"></div>
            <span className="text-secondary-700" data-id="element-317">ICANN Process</span>
          </div>
          <div className="flex items-center gap-2 justify-start" data-id="element-318">
            <div className="w-3 h-3 md:w-4 md:h-4 bg-gradient-to-r from-primary-600 to-primary-700 rounded ring-2 ring-primary-200 flex-shrink-0" data-id="element-319"></div>
            <span className="text-secondary-700 font-semibold" data-id="element-320">
              Early Warning Reports
            </span>
          </div>
          <div className="flex items-center gap-2 justify-start" data-id="element-321">
            <div className="w-3 h-3 md:w-4 md:h-4 bg-gradient-to-r from-red-600 to-red-700 rounded flex-shrink-0" data-id="element-322"></div>
            <span className="text-secondary-700" data-id="element-323">Critical Deadline</span>
          </div>
        </div>
      </div>
    </div>;
}